import { ThemeOptions } from "@mui/material/styles";

import TimeIcon from "assets/svg/time-gray.svg";

export const inputOverrides: ThemeOptions["components"] = {
	MuiInput: {
		styleOverrides: {
			input: ({ theme }) => ({
				"&::-ms-reveal": {
					display: "none",
				},

				"&::-ms-clear": {
					display: "none",
				},

				"&::-webkit-credentials-auto-fill-button": {
					display: "none",
				},

				"&::-webkit-clear-button": {
					display: "none",
				},

				"&::-webkit-search-cancel-button": {
					WebkitAppearance: "none",
					pointerEvents: "none",
				},

				"&::-webkit-calendar-picker-indicator": {
					WebkitAppearance: "none",
					cursor: "pointer",
					width: theme.spacing(3),
					height: theme.spacing(3),
					background: `url(${TimeIcon}) no-repeat center center`,
					backgroundSize: "contain",
				},
			}),
		},
	},
};
